import './package-activity.scss';

import { Outlet } from "react-router-dom";

import { FilterPackageActivityProvider } from "./filter-package-activity/filter-package-activity.context";

export function PackageActivity() {
  return (
    <div id="ShellPackageActivity" className="package-activity">
       <FilterPackageActivityProvider>
        <Outlet />
      </FilterPackageActivityProvider>
    </div>
  );
}

export default PackageActivity;
